import { useEffect, useMemo, useState } from "react";

import { useTheme } from "styled-components";
import { colorKeys } from "theme/constants";

import { ensureLeadingHex } from "./colorUtils";

/**
 * returns the style value of a css property such as "background" from a passed in array of colors.
 * @param {object} param0
 * @param {string[]} param0.colors - an array of colors. Three is best.
 * @param {boolean} param0.startWhite - Set to true to have the gradiant init from white to have a fade-in effect.
 * @returns {string} - i.e. linear-gradient:
 */
const useGradiant = ({ colors: colorsArg, startWhite } = {}) => {
  // A page will always start white, so ease them in to the background color.
  const [showWhite, setShowWhite] = useState(startWhite);

  useEffect(() => {
    if (!startWhite) return;
    // setTimeout ensures the color is white on first render.
    setTimeout(setShowWhite(false));
    window.addEventListener("beforeunload", (e) => {
      setShowWhite(true);
    });
  }, [startWhite]);

  const { palette } = useTheme();

  const colors = useMemo(() => {
    let value = showWhite ? ["#ffffff"] : colorsArg;
    if (!value)
      value = [
        palette[colorKeys.blue],
        palette[colorKeys.brandFnBlue],
        palette[colorKeys.brandFnBlue],
      ];

    while (value.length < 3) value.push(value.slice(-1)[0]);
    return value.map((color) => ensureLeadingHex(color));
  }, [colorsArg, palette, showWhite]);

  return useMemo(() => `linear-gradient(135deg,${colors.join(",")})`, [colors]);
};

export default useGradiant;
